import { registerPlugin } from '@capacitor/core';

export interface MockDetectorPlugin {
  isMock(): Promise<{ mock: boolean; deviceInfo: object; message: string }>;
}

const MockDetector = registerPlugin<MockDetectorPlugin>('MockDetector');

export default MockDetector;
